import { useState, useEffect } from "react";
import { Form, Button, Col, Row, Container, Modal } from "react-bootstrap";
import { faPrint } from "@fortawesome/free-solid-svg-icons";
import { projectFirestore } from "../../../firebase/config";
import { onSnapshot, collection, query, where } from "firebase/firestore";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useAuthContext } from "../../../hooks/useAuthContext";
import "./ModalMesa.css";

import { utilUpdateAsignaciones } from "../../../util/UtilsFirebase";

const ModalMesa = ({
  NumMesa,
  showProducto,
  MesasID,
  asignaciones,
  handleCloseProducto,
}) => {
  const { register } = useAuthContext();
  const [meseros, setMeseros] = useState([]);
  const [meseroSelected, setMeseroSelected] = useState("");

  useEffect(() => {
    const filtros = [
      { campo: "id_puesto", operador: "==", valor: register.id },
      { campo: "id_tipo_puesto", operador: "==", valor: "Mesero" },
    ];
    let q = query(collection(projectFirestore, "personal"));
    filtros.forEach((filtro) => {
      const { campo, operador, valor } = filtro;
      q = query(q, where(campo, operador, valor));
    });
    onSnapshot(q, (docs) => {
      const documentosColeccion = [];
      docs.docs.forEach((doc) => {
        //console.log(doc.id, '=>', doc.data());
        let data = doc.data();
        data.id = doc.id;
        const filtrosa = [
          { campo: "id", operador: "==", valor: data.id_usuario },
        ];
        let qu = query(collection(projectFirestore, "users"));
        filtrosa.forEach((filtroc) => {
          const { campo, operador, valor } = filtroc;
          qu = query(qu, where(campo, operador, valor));
        });
        onSnapshot(qu, (docsu) => {
          const dataU = docsu.docs[0].data();
          data.usuario = dataU.fullName;
          data.correo = dataU.email;
          data.rfc = dataU.rfc;
          data.telefono = dataU.telefono;
          documentosColeccion.push(data);
          setMeseros(documentosColeccion);
        });
      });
    });
  }, [register.id]);

  const printQR = () => {
    var content = document.getElementById("project-mesas");
    var pri = document.getElementById("ifmcontentstoprint").contentWindow;
    pri.document.open();
    pri.document.write(content.innerHTML);
    pri.document.close();
    pri.focus();
    pri.print();
  };
  const handleSelectMesero = (e) => {
    setMeseroSelected(e.target.value);
  };

  const handleCloseLocal = async () => {
    //setProducto(null);
    handleCloseProducto();
  };

  const saveProducto = async () => {
    asignaciones[0]["Mesa " + NumMesa]["Mesero"] = meseroSelected;
    for (let index = 0; index < register.table; index++) {
      const num = index + 1;
      delete asignaciones[0]["Mesa " + num]["datos"];
    }
    utilUpdateAsignaciones(MesasID, asignaciones[0].id, asignaciones[0]);
    handleCloseProducto();
  };

  return (
    <Modal show={showProducto} onHide={handleCloseProducto} size="md">
      <Modal.Header closeButton>
        <Modal.Title>Mesa {NumMesa}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Container>
          <Row>
            <Col>
              <Form>
                <Row>
                  <Col md={12}>
                    <div className="center">
                      <div id="project-mesas">
                        <img
                          className="qr-code"
                          src={
                            "https://quickchart.io/qr?text=R-" +
                            register.id +
                            "-M-" +
                            NumMesa
                          }
                          alt=""
                        ></img>
                      </div>
                    </div>
                    <div className="center-form">
                      <Button
                        variant="primary"
                        className="button"
                        onClick={printQR}
                        type="button"
                      >
                        <FontAwesomeIcon icon={faPrint} /> IMPRIMIR
                      </Button>
                    </div>
                  </Col>
                  {!register.type.includes("truck-admin") ? (
                    <Col md={12}>
                      <Form.Group controlId="razonSocial">
                        <Form.Label>Mesero:</Form.Label>
                        <select
                          value={meseroSelected}
                          onChange={handleSelectMesero}
                        >
                          <option value="">Seleccionar</option>
                          {meseros.map((opcion) => (
                            <option key={opcion.id} value={opcion.id}>
                              {opcion.usuario}
                            </option>
                          ))}
                        </select>
                      </Form.Group>
                    </Col>
                  ) : (
                    <></>
                  )}
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleCloseLocal}>
          CANCELAR
        </Button>
        <Button variant={"primary"} onClick={saveProducto}>
          {"GUARDAR"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalMesa;
